import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';


const Banner = () => {


  return (
    <>
      <section className="ax-custom-banner-sec-wrapper">
        <div className="ax-custom-banner-sec-container">
          <div className="ax-custom-banner-sec-glow-left"></div>
          <div className="ax-custom-banner-sec-badge"
          >
            <span className="ax-custom-banner-sec-dot"></span>
            WE DELIVER E-COMMERCE <span className="highlight">WEBSITE IN 24 WORKING HOURS</span>
          </div>
          <div className="ax-custom-banner-sec-title-group">
            <h1
              className="ax-custom-banner-sec-heading-main"
            >
              Cutting<span className="font-arcade">EDGE</span>
            </h1>
            <h2 className="ax-custom-banner-sec-heading-sub"
            >
              Website <span className="magic-text">MAG<span className="wand">I</span>C</span>
            </h2>
          </div>
          <p className="ax-custom-banner-sec-desc"
          >
            Axesell crafts high-performance, scalable e-commerce websites <br />
            that drive traffic, increase conversions & grow your brand.
          </p>
          <Link to="/book-a-demo">
            <div
              className="btn-wrapper mb-5"
            >
              <button
                className="ax-custom-banner-sec-btn"
              >
                Book Your  Free Demo Now
              </button>
            </div>
          </Link>
          <motion.div
            animate={{
              rotate: [0, 360],
            }}
            transition={{
              duration: 18,
              repeat: Infinity,
              ease: "linear",
            }}
            className="ax-custom-banner-sec-floating-shape"
          >
            <div className='custom-image-banner-sec d-none d-lg-block'>
              <div className="flower-shape">
                <img
                  src="/assets/images/Component 36.webp"
                  alt="Axesell Banner"
                />
              </div>
            </div>
          </motion.div>

        </div>
      </section>
    </>
  );
};

export default Banner;
